import React from "react";
import { STRINGS } from "../../../strings";
import { Patient } from "../../../system/AppState/AppPatientsState";
import { translate } from "../../../translate";
import { fmap } from "../../../utils/fmap";
import { AppCard, AppCardContent } from "../../Generic/AppCard";
import PatientAvatar from "../../PatientAvatar/PatientAvatar";

interface Props {
  patient: Patient;
  onClick: (patient: Patient) => void;
}

const PatientCard = (props: Props) => {
  const fullName = `${props.patient.firstName} ${props.patient.lastName}`;

  const gender = React.useMemo(() => {
    switch (props.patient.gender) {
      case "M":
        return translate(STRINGS.MALE).toUpperCase();
      case "F":
        return translate(STRINGS.FEMALE).toUpperCase();
      default:
        return "";
    }
  }, [props.patient.gender]);

  const PatientDescription = React.useMemo(() => {
    const address2 =
      props.patient.address2 !== null && props.patient.address2 !== ""
        ? `, ${props.patient.address2}`
        : "";
    return (
      <div className="__description">
        <strong className="__name">{fullName}</strong>
        <p className="__address">
          {fmap(props.patient.address, (x) => x.split(", ")[0].concat(address2))}
        </p>
        <span className="__gender">{gender}</span>
      </div>
    );
  }, [gender, fullName, props.patient.address, props.patient.address2]);

  return (
    <AppCard className="PatientCard" onClick={() => props.onClick(props.patient)}>
      <AppCardContent>
        <PatientAvatar initials={props.patient.initials} />
        {PatientDescription}
      </AppCardContent>
    </AppCard>
  );
};

export default React.memo(PatientCard);
